import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "device-details" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-7" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = { class: "field is-grouped is-grouped-right mb-3" }
const _hoisted_7 = { class: "control" }
const _hoisted_8 = { class: "control" }
const _hoisted_9 = { value: "1h" }
const _hoisted_10 = { value: "1d" }
const _hoisted_11 = { value: "7d" }
const _hoisted_12 = { value: "15d" }
const _hoisted_13 = { value: "30d" }
const _hoisted_14 = { class: "column is-5" }
const _hoisted_15 = { class: "box" }
const _hoisted_16 = { class: "title is-5" }
const _hoisted_17 = { class: "table is-fullwidth" }
const _hoisted_18 = { class: "is-flex is-align-items-center" }
const _hoisted_19 = { class: "is-flex is-align-items-center" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "has-text-grey"
}
const _hoisted_22 = { class: "buttons is-right" }
const _hoisted_23 = { class: "box mt-4" }
const _hoisted_24 = { class: "title is-5" }
const _hoisted_25 = {
  key: 0,
  class: "has-text-grey"
}
const _hoisted_26 = {
  key: 1,
  class: "table is-fullwidth is-striped"
}
const _hoisted_27 = { style: {"width":"50%"} }
const _hoisted_28 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_29 = { class: "has-text-grey" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "has-text-right" }
const _hoisted_33 = { class: "box mt-4" }
const _hoisted_34 = { class: "title is-5" }
const _hoisted_35 = {
  key: 0,
  class: "has-text-grey"
}
const _hoisted_36 = {
  key: 1,
  class: "table is-fullwidth is-striped"
}
const _hoisted_37 = { class: "has-text-right" }
const _hoisted_38 = {
  key: 0,
  class: "has-text-danger"
}
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 2,
  class: "has-text-grey"
}
const _hoisted_41 = { class: "has-text-right" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "has-text-centered" }
const _hoisted_44 = { class: "is-size-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_InlineNameEditor = _resolveComponent("InlineNameEditor")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_EventsStreamTable = _resolveComponent("EventsStreamTable")!
  const _component_b_tab_item = _resolveComponent("b-tab-item")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_select = _resolveComponent("b-select")!
  const _component_Line = _resolveComponent("Line")!
  const _component_b_tabs = _resolveComponent("b-tabs")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!
  const _component_b_input = _resolveComponent("b-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.selectedDevice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_b_breadcrumb, {
            size: "is-large",
            separator: "has-succeeds-separator",
            "aria-label": "breadcrumbs"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_breadcrumb_item, {
                tag: "a",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({name: 'device-list'})), ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('global.devices')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_b_breadcrumb_item, {
                tag: "span",
                active: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InlineNameEditor, {
                    "model-value": _ctx.selectedDevice?.name || _ctx.id,
                    "can-edit": !!_ctx.selectedDevice,
                    placeholder: _ctx.$t('devices.name'),
                    save: _ctx.saveDeviceName
                  }, null, 8, ["model-value", "can-edit", "placeholder", "save"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_b_tabs, {
                  modelValue: _ctx.activeTab,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTab) = $event)),
                  expanded: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_tab_item, {
                      label: _ctx.$t('devices.events')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_EventsStreamTable, {
                          topics: _ctx.deviceEventTopics,
                          stripPrefix: _ctx.deviceEventsPrefix,
                          maxHeight: _ctx.eventsTableHeight,
                          size: "is-small"
                        }, null, 8, ["topics", "stripPrefix", "maxHeight"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_b_tab_item, { label: "Vitals" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("p", _hoisted_7, [
                            _createVNode(_component_b_button, {
                              class: "is-primary is-small",
                              onClick: _ctx.loadStats,
                              loading: _ctx.statsLoading,
                              disabled: _ctx.statsLoading,
                              "icon-left": "reload",
                              title: _ctx.$t('global.refresh')
                            }, null, 8, ["onClick", "loading", "disabled", "title"])
                          ]),
                          _createElementVNode("p", _hoisted_8, [
                            _createVNode(_component_b_select, {
                              size: "is-small",
                              modelValue: _ctx.window,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.window) = $event)),
                              onChange: _ctx.loadStats
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t('charts.last_1h')), 1),
                                _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t('charts.last_1d')), 1),
                                _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t('charts.last_7d')), 1),
                                _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('charts.last_15d')), 1),
                                _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t('charts.last_30d')), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ])
                        ]),
                        _createVNode(_component_Line, {
                          ref: "rssiChart",
                          data: _ctx.rssiData,
                          options: _ctx.rssiOptions,
                          width: "100%"
                        }, null, 8, ["data", "options"]),
                        _createVNode(_component_Line, {
                          ref: "heapChart",
                          data: _ctx.heapData,
                          options: _ctx.heapOptions,
                          width: "100%"
                        }, null, 8, ["data", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t('devices.details')), 1),
                _createElementVNode("table", _hoisted_17, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('devices.name')) + ":", 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_InlineNameEditor, {
                            "model-value": _ctx.selectedDevice?.name || _ctx.id,
                            "can-edit": !!_ctx.selectedDevice,
                            placeholder: _ctx.$t('devices.name'),
                            save: _ctx.saveDeviceName,
                            "show-copy": ""
                          }, null, 8, ["model-value", "can-edit", "placeholder", "save"])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('devices.id')) + ":", 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedDevice.id), 1),
                          _createVNode(_component_CopyToClipboard, {
                            value: _ctx.selectedDevice.id,
                            title: "Copy"
                          }, null, 8, ["value"])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('devices.model')) + ":", 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.selectedDevice.model), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('devices.status')) + ":", 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t('status.' + _ctx.selectedDevice.status)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('devices.lastConnect')) + ":", 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$d(new Date(_ctx.selectedDevice.updatedAt), 'short')), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('devices.lastSeen')) + ":", 1)
                      ]),
                      _createElementVNode("td", null, [
                        (_ctx.lastSeen)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$d(new Date(_ctx.lastSeen), 'short')), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, "—"))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.selectedDevice)
                    ? (_openBlock(), _createBlock(_component_b_button, {
                        key: 0,
                        type: "is-danger",
                        "icon-left": "delete",
                        onClick: _ctx.confirmDeleteDevice,
                        title: _ctx.$t('devices.confirmTooltop')
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('devices.remove')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "title"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t('devices.functions')), 1),
                (_ctx.deviceFunctions.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t('devices.noFunctions')), 1))
                  : (_openBlock(), _createElementBlock("table", _hoisted_26, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('devices.function')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('devices.parameter')), 1),
                          _cache[4] || (_cache[4] = _createElementVNode("th", { class: "has-text-right" }, "Action", -1))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceFunctions, (fn) => {
                          return (_openBlock(), _createElementBlock("tr", { key: fn }, [
                            _createElementVNode("td", null, [
                              _createElementVNode("code", null, _toDisplayString(fn), 1)
                            ]),
                            _createElementVNode("td", _hoisted_27, [
                              _createVNode(_component_b_input, {
                                modelValue: _ctx.functionsParams[fn],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.functionsParams[fn]) = $event),
                                size: "is-small",
                                placeholder: _ctx.$t('devices.functionParamPlaceholder')
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                              (_ctx.functionResults[fn] !== undefined)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("small", _hoisted_29, [
                                      _cache[5] || (_cache[5] = _createTextVNode("Last result: ", -1)),
                                      (_ctx.functionResults[fn] === null)
                                        ? (_openBlock(), _createElementBlock("strong", _hoisted_30, _toDisplayString(_ctx.$t('devices.invalidFormat')), 1))
                                        : (_openBlock(), _createElementBlock("strong", _hoisted_31, _toDisplayString(_ctx.functionResults[fn]), 1))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              _createVNode(_component_b_button, {
                                size: "is-small",
                                onClick: ($event: any) => (_ctx.callFunction(fn)),
                                disabled: _ctx.isMQTTConnecting
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('global.call')), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick", "disabled"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("h3", _hoisted_34, _toDisplayString(_ctx.$t('devices.variables')), 1),
                (_ctx.deviceVariables.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.$t('devices.noVariables')), 1))
                  : (_openBlock(), _createElementBlock("table", _hoisted_36, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('devices.variable')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('devices.value')), 1),
                          _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.$t('global.action')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceVariables, (vr) => {
                          return (_openBlock(), _createElementBlock("tr", { key: vr }, [
                            _createElementVNode("td", null, [
                              _createElementVNode("code", null, _toDisplayString(vr), 1)
                            ]),
                            _createElementVNode("td", null, [
                              (_ctx.variablesValues[vr] === null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('devices.invalidFormat')), 1))
                                : (_ctx.variablesValues[vr] !== undefined)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.variablesValues[vr]), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_40, "—"))
                            ]),
                            _createElementVNode("td", _hoisted_41, [
                              _createVNode(_component_b_button, {
                                size: "is-small",
                                onClick: ($event: any) => (_ctx.readVariable(vr)),
                                disabled: _ctx.isMQTTConnecting
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('global.read')), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick", "disabled"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t('devices.notFound')), 1),
            _createVNode(_component_b_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({name: 'device-list'}))),
              class: "mt-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('global.back')), 1)
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}